module.exports = function (animate = true) {
	var $content = $('.C2-search-results');
	$content.append(
		'<div class="C2-search-results__loading-overlay"><div class="C2-search-results__loading loading"><div class="loading__dots">Loading...</div></div></div>');

	Innophos.Pages.ProductSearchPage.Search(function (results) {
		$content.html(results);

		Innophos.Pages.ProductSearchPage.PaginationEvents();
		Innophos.Pages.ProductSearchPage.CartEvents();

		if (animate) {
			$('html, body').animate({ scrollTop: 0 });
		}
		
		$content.find('.C2-search-results__loading-overlay').remove();
	});
};
